/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::573ec388b005b16cfabb95e4ea3d026a>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UNSAFE_baseNew = _interopRequireDefault(require("@atlaskit/icon/UNSAFE_base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChildIssues".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for child issues in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const ChildIssuesIcon = props => /*#__PURE__*/_react.default.createElement(_UNSAFE_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var _default = exports.default = ChildIssuesIcon;